<script setup>
  import {
    computed,
    nextTick,
    onMounted,
    ref,
  } from 'vue'

  import Property from '@components/PropertySmall.vue'

  import { useI18n } from '@shared/i18n.js'
  import { useAjax } from '@composables/useAjax.js'
  import { useSwiper } from '@composables/useSwiper.js'
  import { shuffleArray } from '@shared/util.js'

  const props = defineProps({
    title: String,
    type: String,
  })

  const emits = defineEmits(['load'])

  const { vt } = useI18n('welcome.index.js')

  const properties = ref(null)

  const path = window.app.page.properties_path[props.type]
  const maxCount = 5

  const { callGet } = useAjax()
  const { swiperSlider } = useSwiper()

  const id = computed(() => ['properties', props.type].join('-'))

  onMounted(() => getProperties())

  const initializeSwiper = () => nextTick(() => swiperSlider(`#${id.value} .c-slider`))

  const getProperties = async () => {
    const response = await callGet(`${path}.json`)
    if (response.properties && response.properties.length > 0) {
      Promise.allSettled(shuffleArray(response.properties).slice(0, maxCount).map((property) => callGet(property.path)))
        .then((results) => {
          emits('load')
          properties.value = results.filter((result) => result.status == 'fulfilled').map((result) => result.value.property)
          initializeSwiper()
        })
    }
    else {
      properties.value = []
    }
  }
</script>

<template>
  <section v-if="properties && properties.length > 0" :id="id" class="sec_guide">
    <h2 class="sec-title">{{ title }}</h2>
    <div class="property_botoom_slide p-guides-detail-slide">
      <div class="listing">
        <div class="slider swiper c-slider">
          <div class="swiper-wrapper">
            <template v-for="property in properties" :key="`${id}-${property.path}`">
              <Property :property="property" :show-status="false" />
            </template>

            <div class="item item-view-more swiper-slide">
              <a :href="path">
                <p>{{ vt('view_more_properties') }}</p>
              </a>
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>
    <slot></slot>
  </section>
</template>
